
import axios from "axios";
import i18n from "../i18n";


export const apiPath = "https://api.copysa.ir";


export const Axios = axios.create({
  baseURL: apiPath + "/api",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to inject 'lang'
Axios.interceptors.request.use((config) => {
  const lang = i18n.language || 'fa';
  if (config.method === 'get' || config.method === 'delete') {
    // Add lang as a query parameter
    config.params = config.params || {};
    config.params.lang = lang;
  } else if (config.method === 'post' || config.method === 'put' || config.method === 'patch') {
    // Add lang to the request body
    if (config.headers['Content-Type'] === 'multipart/form-data') {
      // For FormData, append lang
      if (config.data instanceof FormData) {
        config.data.append('lang', lang);
      }
    } else {
      // For JSON body
      config.data = config.data || {};
      config.data.lang = lang;
    }
  }
  return config;
}, (error) => Promise.reject(error));
